import { render, staticRenderFns } from "./OnboardingTourModal.vue?vue&type=template&id=1cf277e0&scoped=true&"
import script from "./OnboardingTourModal.vue?vue&type=script&lang=ts&"
export * from "./OnboardingTourModal.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingTourModal.vue?vue&type=style&index=0&id=1cf277e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf277e0",
  null
  
)

export default component.exports